import MuiAlert from '@mui/material/Alert';
import MuiAlertTitle from '@mui/material/AlertTitle';
import MuiCircularProgress from '@mui/material/CircularProgress';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogContentText from '@mui/material/DialogContentText';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiLinearProgress from '@mui/material/LinearProgress';
import MuiPopover from '@mui/material/Popover';
import { wrap } from '../wrap';

/**
 * `severity` keeps its name. It is not vendor vocabulary — an alert being an
 * error or a warning is the concept itself, and any replacement calls it the
 * same thing.
 */
export const Alert = wrap(MuiAlert, 'Alert', { tone: true, emphasis: 'alert' });
export const AlertTitle = wrap(MuiAlertTitle, 'AlertTitle');

/** `size` here is a diameter in pixels, not a t-shirt size, so it passes through. */
export const CircularProgress = wrap(MuiCircularProgress, 'CircularProgress', { tone: true });
export const LinearProgress = wrap(MuiLinearProgress, 'LinearProgress', { tone: true });

export const Dialog = wrap(MuiDialog, 'Dialog', {
  keep: ['maxWidth'], slots: { PaperProps: 'paper' },
});
export const DialogTitle = wrap(MuiDialogTitle, 'DialogTitle');
export const DialogContent = wrap(MuiDialogContent, 'DialogContent');
export const DialogContentText = wrap(MuiDialogContentText, 'DialogContentText');
export const DialogActions = wrap(MuiDialogActions, 'DialogActions');
export const Popover = wrap(MuiPopover, 'Popover', {
  keep: ['anchorOrigin', 'transformOrigin'], slots: { PaperProps: 'paper' },
});
